import { render, staticRenderFns } from "./IdentityVerificationSection2.vue?vue&type=template&id=56ca3668&scoped=true&"
import script from "./IdentityVerificationSection2.vue?vue&type=script&lang=js&"
export * from "./IdentityVerificationSection2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca3668",
  null
  
)

export default component.exports